import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <h1 className="text-5xl lg:text-6xl font-bold text-black leading-tight mb-8">
            {t('nav.about')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl leading-relaxed">
            {t('about.title')}
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/a637c0ee9ec9ccc82f491078a76828c2.jpg" 
                alt="Professional Team" 
                className="w-full h-auto rounded-lg shadow-lg object-cover object-top"
              />
            </div>
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {t('about.client')}
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                {t('about.approach')}
              </p>
            </div>
          </div>

          {/* Mission, Expertise, Values */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-20">
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black">
                {t('about.mission.title')}
              </h3>
              <p className="text-base text-gray-700 leading-relaxed">
                {t('about.mission.desc')}
              </p>
            </div>
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black">
                {t('about.expertise.title')}
              </h3>
              <p className="text-base text-gray-700 leading-relaxed">
                {t('about.expertise.desc')}
              </p>
            </div>
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black">
                {t('about.values.title')}
              </h3>
              <p className="text-base text-gray-700 leading-relaxed">
                {t('about.values.desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
